import type {StateCreator} from 'zustand'

export interface ComparisonOutdatedSlice {
  /**
   * Indicates whether the current comparison (base/head OIDs) is up to date.
   * Becomes false when there are pushes to the pull request that change the base or head commit and the user
   * has not yet refreshed the comparison.
   */
  isComparisonOutdated: boolean
  comparisonOutdatedActions: {
    markComparisonOutdated: () => void
    clearComparisonOutdated: () => void
  }
}

export const createComparisonOutdatedSlice: StateCreator<
  ComparisonOutdatedSlice,
  [['zustand/devtools', never]]
> = set => ({
  isComparisonOutdated: false,
  comparisonOutdatedActions: {
    markComparisonOutdated: () =>
      set(
        () => ({
          isComparisonOutdated: true,
        }),
        undefined,
        'comparisonOutdated#markComparisonOutdated',
      ),
    clearComparisonOutdated: () =>
      set(
        () => ({
          isComparisonOutdated: false,
        }),
        undefined,
        'comparisonOutdated#clearComparisonOutdated',
      ),
  },
})
